import { Badge, Collapse, Flex, Space, Typography } from 'antd'
import { useBudgetListOwn } from 'src/pages/budget/budgetRequests/hooks'
import { OwnRejectTable } from './components'
import styles from './styles.module.css'
import { TStatusPeriod } from 'src/pages/budget/types'

type Props = {
  budgetPeriodName: string | null
  currentPeriodStatus?: TStatusPeriod
}
export const RequestListOwnReject = ({ budgetPeriodName }: Props) => {
  const { budgetListOwnReject, filteredBudgetListOwnReject } =
    useBudgetListOwn()
  const { Text } = Typography
  if (
    !budgetListOwnReject ||
    !filteredBudgetListOwnReject ||
    budgetListOwnReject.length === 0
  )
    return null
  return (
    <Collapse
      items={[
        {
          key: '1',
          label: (
            <Space>
              <Text strong style={{ fontSize: 28 }}>
                Мои отклоненные заявки / {budgetPeriodName ?? ''}
              </Text>
              <Badge
                count={filteredBudgetListOwnReject.length}
                showZero
                color="white"
                style={{ color: 'black', borderRadius: '4px' }}
              />
            </Space>
          ),
          children: (
            <Flex align="center" justify="center" style={{ minHeight: '15em' }}>
              <OwnRejectTable
                list={budgetListOwnReject}
                filterList={filteredBudgetListOwnReject}
              />
            </Flex>
          ),
        },
      ]}
      className={styles.collapse}
      defaultActiveKey="1"
      expandIconPosition="end"
      style={{ backgroundColor: 'var(--color-red-20)' }}
    />
  )
}
